import { ResultatAngivesIEnum } from './enums/ResultatAngivesIEnum';
import { OpgaveBedoemmesAfEnum } from './enums/OpgaveBedoemmesAfEnum';
import { OpgavenBedoemmesEfterEnum } from './enums/OpgavenBedoemmesEfterEnum';
import { DelopgaveBedoemmelsesFaktor } from './DelopgaveBedoemmelsesFaktor';

export class DelopgaveListItem {
        public id: string;
        public opgaveId: string;
        public opgavepakkeId: string;
        public resultatetAngivesI: ResultatAngivesIEnum;
        public opgavenBedoemmesAf: OpgaveBedoemmesAfEnum;
        public opgavenBedoemmesEfter: OpgavenBedoemmesEfterEnum;
        public kendtVaerdi: string;
        public bedoemmelsesvejledning: string;
        public indhold: string;
        public titel: string;
        public skalStartesManuelt: boolean;
        public afslutningstidspunkt: Date;
        public delopgaveBedoemmelsesFaktorer: DelopgaveBedoemmelsesFaktor[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/DelopgaveListItem.ts